module.exports = __webpack_public_path__ + "img/ob_16.859ddff7.jpg";